import { render, staticRenderFns } from "./v1.vue?vue&type=template&id=a4e2d0da&scoped=true&"
import script from "./v1.vue?vue&type=script&lang=js&"
export * from "./v1.vue?vue&type=script&lang=js&"
import style0 from "./v1.vue?vue&type=style&index=0&id=a4e2d0da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e2d0da",
  null
  
)

export default component.exports